"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
const DesktopHeaderSkeleton = () => {
  return /*#__PURE__*/_react.default.createElement(_styles.StepperSkeletonContainer, null, /*#__PURE__*/_react.default.createElement(_styles.StepperShimmerCircle, null), /*#__PURE__*/_react.default.createElement(_styles.StepperShimmerSquare, null), /*#__PURE__*/_react.default.createElement(_styles.StepperShimmerLine, null), /*#__PURE__*/_react.default.createElement(_styles.StepperShimmerCircle, null), /*#__PURE__*/_react.default.createElement(_styles.StepperShimmerSquare, null), /*#__PURE__*/_react.default.createElement(_styles.StepperShimmerLine, null), /*#__PURE__*/_react.default.createElement(_styles.StepperShimmerCircle, null), /*#__PURE__*/_react.default.createElement(_styles.StepperShimmerSquare, null), /*#__PURE__*/_react.default.createElement(_styles.StepperShimmerLine, null), /*#__PURE__*/_react.default.createElement(_styles.StepperShimmerCircle, null), /*#__PURE__*/_react.default.createElement(_styles.StepperShimmerSquare, null));
};
var _default = exports.default = DesktopHeaderSkeleton;
DesktopHeaderSkeleton.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DesktopHeaderSkeleton"
};